import { put } from 'redux-saga/effects';
import { verifyPhoneSetErrorMessageAction } from '@cian/sms-validation-widget';

export function* verifyPhoneCloseModal() {
  yield put(verifyPhoneSetErrorMessageAction(''));
}
